module.exports = __webpack_public_path__ + "media/images/items/thumbnail-5-001f1c9f4f30802eaf49b39e13f30963.jpg";